<template>
	<section class="app-priority shadow">
		<div class="container">
			<div class="priority-wrapper u-s-p-b-80">
				<div class="row">
					<div class="col-lg-3 col-md-3 col-sm-3">
						<div class="single-item-wrapper">
							<div class="single-item-icon">
								<i class="ion ion-md-star"></i>
							</div>
							<h2>Great Value</h2>
							<p>We offer competitive prices on our 100 million plus product range</p>
						</div>
					</div>
					<div class="col-lg-3 col-md-3 col-sm-3">
						<div class="single-item-wrapper">
							<div class="single-item-icon">
								<i class="ion ion-md-cash"></i>
							</div>
							<h2>Shop with Confidence</h2>
							<p>Our Protection covers your purchase from click to delivery</p>
						</div>
					</div>
					<div class="col-lg-3 col-md-3 col-sm-3">
						<div class="single-item-wrapper">
							<div class="single-item-icon">
								<i class="ion ion-ios-card"></i>
							</div>
							<h2>Safe Payment</h2>
							<p>Pay with the world’s most popular and secure payment methods</p>
						</div>
					</div>
					<div class="col-lg-3 col-md-3 col-sm-3">
						<div class="single-item-wrapper">
							<div class="single-item-icon">
								<i class="ion ion-md-contacts"></i>
							</div>
							<h2>24/7 Help Center</h2>
							<p>Round-the-clock assistance for a smooth shopping experience</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {};
</script>

<style scoped>
.app-priority{
    background-color: #343a40;
}
.priority-wrapper{
    padding: 30px;
}
.priority-wrapper h2,p,i{
    color: white !important;
}
</style>
